import type { PropsWithChildren } from "react";

export function Badge({ variant = "secondary", children }: PropsWithChildren<{ variant?: string }>) {
  return <span className={`badge badge-${variant}`}>{children}</span>;
}

